<template>
    <div>
        <v-dialog
            v-model="renewalStartDateDialog"
            width="400px">
            <v-card class="text-center">
                <v-card-title class="sansation_title"></v-card-title>
                <v-card-text v-if="renewWorking"
                    class="py-12 py-12">
                    <v-progress-circular
                        size="100"
                        width="4"
                        indeterminate
                        color="primary darken-1">
                    </v-progress-circular>
                    <p class="sansation_subtitle mt-8">Processing your renewal...</p>
                </v-card-text>

                <v-card-text v-else>
                    <p class="sansation_subtitle">Please provide a start date for the new project.</p>

                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="newStartDate"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            hide-details>
                        </v-text-field>
                    </template>

                    <v-date-picker
                        v-model="newStartDate">
                        <div class="d-flex d-block justify-space-between" style="width: 100%">
                            <v-btn 
                                text 
                                color="error" 
                                @click="renewalStartDateDialog = false">
                                Cancel
                            </v-btn>
                            <v-btn 
                                outlined
                                color="primary" 
                                @click="renewProject()">
                                Renew Now
                            </v-btn>
                        </div>
                    </v-date-picker>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-btn 
            class="white--text"
            color="primary darken-1"
            @click="confirmationToRenew(projectDetails)">
            {{ projectDetails.modinfo.module_key === 'entity-maintenance-program' ? `Renew Now` : `Renew This Project` }}
        </v-btn>
    </div>
</template>

<script>
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../../helpers/environment'
    import { getModuleDataByKey } from '../shared/projectFunctions'

    export default {
        name: 'ProjectRenewButton',

        props: {
            projectDetails: Object,
            projectRenewalCleanup: Function,
            triggerUserFeedback: Function,
        },

        data() {
            return {
                renewalStartDateDialog: false,
                renewWorking: false,
                newStartDate: '',
            }
        },

        computed: {
            newYear: function () {
                // console.log('nowYear: ', new Date().getFullYear());
                // console.log('projectYear+1: ', new Date(this.projectDetails.date_initialized).getFullYear() + 1);
                // console.log('newYear: ',new Date(this.projectDetails.date_initialized).getFullYear() + 1 <= new Date().getFullYear() ? new Date().getFullYear() : new Date(this.projectDetails.date_initialized).getFullYear() + 1);
                return new Date(this.projectDetails.date_initialized).getFullYear() + 1 <= new Date().getFullYear() ? new Date().getFullYear() : new Date(this.projectDetails.date_initialized).getFullYear() + 1;
            }
        },

        methods: {
            getDefaultRenewalStartDate: function () {
                const sourceDate = this.projectDetails && this.projectDetails.date_initialized
                    ? String(this.projectDetails.date_initialized)
                    : ''

                const dateOnlyMatch = sourceDate.match(/^(\d{4})-(\d{2})-(\d{2})/)
                if ( !dateOnlyMatch ) {
                    return new Date().toISOString().split('T')[0]
                }

                const month = dateOnlyMatch[2]
                const day = dateOnlyMatch[3]
                return `${this.newYear}-${month}-${day}`
            },

            confirmationToRenew: function () {
                const renewConfirm = confirm("Are you sure you want to renew this project? This will archive this project.");
                if ( renewConfirm ) {
                    this.newStartDate = this.getDefaultRenewalStartDate();
                    this.renewalStartDateDialog = true;
                }
            },

            renewProject: async function () {
                try {
                    this.renewWorking = true

                    let new_project_data = {}
                    switch ( this.projectDetails.modinfo.module_key ) {
                        case 'valuation-elite':     new_project_data = await getModuleDataByKey('enterprise-value');    break; // Valuation Elite -> EnterpriseValue
                        case 'valuation-premium':   new_project_data = await getModuleDataByKey('practice-value');      break; // Valuation Premium -> PracticeValue
                        case 'valuation-starter':   new_project_data = await getModuleDataByKey('core-value');          break; // Valuation Starter -> CoreValue
                        default:                    new_project_data = { ...this.projectDetails.modinfo };              break; // Default -> No change, use the same module data
                    }

                    const projectTeam = this.projectDetails.project_team != null
                        ? this.projectDetails.project_team
                        : (new_project_data && new_project_data.srg_team ? new_project_data.srg_team.experts : [])

                    const currentReportDate = new Date(this.projectDetails.annual_report_filing_date);
                    const chosenStartDate = this.newStartDate;
                    
                    const renew_project_request = await axios.post(`${appUrls.api}/api/admin/add_module`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            user_id: this.projectDetails.user_id,
                            module: new_project_data,
                            project_id: this.projectDetails.project_id,
                            is_annual: this.projectDetails.is_annual,
                            auto_renew: this.projectDetails.auto_renew,
                            expedite: this.projectDetails.expedite,
                            project_team: projectTeam,
                            salesperson_info: this.projectDetails.salesperson_info,
                            currentReportDate,
                            chosenStartDate,
                            internalProjectTitle: this.projectDetails.internal_project_title,
                            projectTitle: this.projectDetails.project_title,
                            recommendedAnnualMeetingDate: this.projectDetails.recommended_annual_meeting_date,
                        }
                    });

                    if( renew_project_request.data.outcome ){
                        this.renewWorking = false;
                        this.renewalStartDateDialog = false;
                        this.$emit('triggerUserFeedback', true, renew_project_request.data.message );

                        setTimeout(() => {
                            this.archiveClonedProject( this.projectDetails )
                        }, 500)
                    }
                } catch (error) {
                    this.renewWorking = false;
                    this.renewalStartDateDialog = false;
                    console.error("Error renewing project:", error);
                }
            },

            archiveClonedProject: async function( prj ) {
                try {
                    const disable_project = await axios.post(`${appUrls.api}/api/admin/disable_project`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            action: "archive",
                            project_id: prj.project_id,
                            module_name: prj.modinfo.module_name,
                            project_status: prj.status
                        }
                    })
                    if ( disable_project.data.outcome ) {
                        this.$emit('projectRenewalCleanup')
                    }
                } catch (error) {
                    console.error("Error archiving project:", error);
                }
            }
        }
    }
</script>

<style scoped>
    .start-date-picker {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/projectRenewButton.vue